import React, { useState } from "react";
import PageHeader from "../components/PageHeader"; // imported header for breadcrumb
import Members from "../components/common/MembersCard";


function TeamPage() {
  const [selectedMember, setSelectedMember] = useState(null);

   // Breadcrumbs for PageHeader
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Team", active: true },
  ];

  return (
    <>
    <PageHeader title="Our Team" breadcrumbs={breadcrumbs} />
    <div className="container-xxl py-5">
      <div className="container">
         <Members />
      </div>
    </div>
    </>
  );
}

export default TeamPage;
